/*
 * @Author: your name
 * @Date: 2020-05-26 19:40:04
 * @LastEditTime: 2020-06-08 18:29:50
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\api\base.js
 */
/**
 * 接口域名的管理
 */
let base = {
    dev: '',
}
if(process.env.NODE_ENV === 'production') {
    base.dev = process.env.VUE_APP_BASE_API
} else {
    // base.dev = 'https://api.efashion-paris.com/' // process.env.VUE_APP_BASE_API
    base.dev = process.env.VUE_APP_BASE_API
}

export default base;
